import React from "react";
import { Grid } from "@mui/material";

import { BrandAssetContent, LogoType } from "../types";
import { LOGO_TYPES } from "../constants";
import LogoUploadField from "./LogoUploadField";

interface LogosPanelProps {
  logos: BrandAssetContent["logos"];
  onChange: (type: LogoType, dataUrl: string) => void;
}

const LogosPanel: React.FC<LogosPanelProps> = ({ logos, onChange }) => (
  <Grid container spacing={2}>
    {LOGO_TYPES.map((type) => (
      <Grid item xs={12} sm={6} md={4} key={type}>
        <LogoUploadField
          type={type}
          value={logos[type]}
          onChange={(dataUrl) => onChange(type, dataUrl)}
        />
      </Grid>
    ))}
  </Grid>
);

export default LogosPanel;
